import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page--limited card" }
const _hoisted_2 = { class: "p-grid" }
const _hoisted_3 = { class: "p-col" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "p-col p-text-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "p-m-0" }, "Activity Detail Data")
], -1)
const _hoisted_5 = { class: "p-col p-text-right" }
const _hoisted_6 = { class: "p-p-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackButton = _resolveComponent("BackButton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_TabMenu = _resolveComponent("TabMenu")!
  const _component_router_view = _resolveComponent("router-view")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_BackButton, { to: _ctx.backRoute }, null, 8, ["to"])
      ]),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (!_ctx.isNew)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              label: "Create WRS",
              class: "p-mr-1 p-button-secondary",
              onClick: _ctx.createWRS,
              disabled: _ctx.requestPending
            }, null, 8, ["onClick", "disabled"]))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_Button, {
          icon: "pi pi-save",
          class: "p-mr-1",
          onClick: _ctx.onSave,
          disabled: _ctx.requestPending
        }, null, 8, ["onClick", "disabled"]), [
          [
            _directive_tooltip,
            _ctx.$t('save'),
            void 0,
            { bottom: true }
          ]
        ])
      ])
    ]),
    _createVNode(_component_TabMenu, { model: _ctx.tabs }, null, 8, ["model"]),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({Component}) => [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(), _createBlock(_KeepAlive, null, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
              activity: _ctx.activity,
              isLoading: _ctx.requestPending,
              onSave: _ctx.onSave
            }, null, 8, ["activity", "isLoading", "onSave"]))
          ], 1024))
        ])
      ]),
      _: 1
    })
  ]))
}